import { render, staticRenderFns } from "./SearchBoxEmpresa.vue?vue&type=template&id=0062ac53&scoped=true"
import script from "./SearchBoxEmpresa.vue?vue&type=script&lang=js"
export * from "./SearchBoxEmpresa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../paylogos-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0062ac53",
  null
  
)

export default component.exports